import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-staff-policies',
  templateUrl: './staff-policies.component.html',
  styleUrls: ['./staff-policies.component.css']
})
export class StaffPoliciesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
